import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => createStyles({
  registerButton: {
    [theme.breakpoints.down('sm')]: {
      '& .MuiButtonBase-root': {
        width: '100%',
      },
    },
  },
}))
